module.exports = __webpack_public_path__ + "img/bat.d10277aa.png";